import { render, staticRenderFns } from "./ToggleButtonConfig.vue?vue&type=template&id=68974694&scoped=true"
import script from "./ToggleButtonConfig.vue?vue&type=script&lang=js"
export * from "./ToggleButtonConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68974694",
  null
  
)

export default component.exports